export default "__VITE_PUBLIC_ASSET__f505cd93__"